export interface ApiCategory {
  id: string;
  attributes: ApiCategoryAttributes;
}

interface ApiCategoryAttributes {
  name: string;
  color: string;
  group: string;
}

export async function apiGetCategories(): Promise<ApiCategory[]> {
  const results = await fetch(
    `${process.env.REACT_APP_API_ENDPOINT}/v3/categories`,
    { credentials: 'include' }
  );

  if (results.ok) {
    const json = await results.json();

    return json.data;
  } else {
    throw results.body;
  }
}
